import { useSelector } from "react-redux";

import { CirclePlusIcon, POIIcon } from "@/assets/icons";
import { useAppFeatures } from "@/hooks/useAppFeatures";
import { RootState } from "@/store";

import { Button } from "equator-design-system";

import { AreaSummaryCard } from "../spatialAnalysis/spatialAreaInput/areaSummaryCard";

const TEST_ID_PREFIX = "global-filter";

type Props = {
  onOpenFilter: () => void;
  onClearFilter: () => void;
};

export const GlobalFilter = ({ onOpenFilter, onClearFilter }: Props) => {
  const { isAdminTreeEnabled } = useAppFeatures();
  const { showGlobalFilterPopup } = useSelector((state: RootState) => state.ui);
  const { explicitSelectedAreaIds, adminAreaSettings } = useSelector(
    (state: RootState) => state.globalFilter
  );

  const hasData = explicitSelectedAreaIds.length > 0 || adminAreaSettings?.lv0;

  return (
    <div className="flex flex-col px-4">
      <span className="font-sans font-semibold text-txtHeading text-sm">
        Filter Area
      </span>
      <p className=" text-txtBody font-sans text-[10px]">
        Define a global area filter applied to all datasets and analyses.
      </p>

      {/* Saved Global Filter */}
      <AreaSummaryCard
        countryLabel={adminAreaSettings?.lv0?.label}
        isTreeEnabled={isAdminTreeEnabled}
        selectedAreaCount={explicitSelectedAreaIds.length}
        adminAreaSettings={adminAreaSettings}
        emptyState={
          <div className="my-2 rounded-lg flex items-center gap-2 p-4 bg-white-smoke">
            <POIIcon className="fill-light-gray w-8 h-8" />
            <div className="text-xs">
              No Global Filter Area yet. Set one to get started.
            </div>
          </div>
        }
        onClear={onClearFilter}
        disabledClear={showGlobalFilterPopup}
      />

      <Button
        className="h-[32px] mt-3 btn-secondary text-sm font-bold"
        onClick={onOpenFilter}
        data-testid={`${TEST_ID_PREFIX}-set-filter-area-button`}
      >
        {!hasData && <CirclePlusIcon className="fill-teal-500" />}
        <span>{hasData ? "Edit" : "Set"} Filter Area</span>
      </Button>
    </div>
  );
};
